// extracted by mini-css-extract-plugin
export var cardContainer = "_nc-0";
export var cardHeader = "_nc-2";
export var collapsedState = "_nc-3";
export var dragHandle = "_nc-5";
export var dragHandleIcon = "_nc-6";
export var dragging = "_nc-1";
export var titleArea = "_nc-4";